import { createAction, props } from '@ngrx/store';
import { StoreModel } from '../_models';

// Action types
export const loadStoreModels = createAction('[StoreModel] Load StoreModels');
export const loadStoreModelsSuccess = createAction(
  '[StoreModel] Load StoreModels Success',
  props<{ storeModels: StoreModel[] }>()
);
export const loadStoreModelsFailure = createAction(
  '[StoreModel] Load StoreModels Failure',
  props<{ error: any }>()
);
